module.exports = __webpack_public_path__ + "static/media/1015094.f3a83994.jpg";